// consts
import { TYPE } from 'app/config/prescription_content';
import { ITEM } from 'app/config/prescription_item';
// utils
import _ from 'lodash';

export class PadPrescriptionType {
  constructor({ screenData, loadedData, currentData }) {
    this._currentData = currentData;
    this._screenData = screenData;
    this._loadedData = loadedData;
  }

  getTypeOnAdd() {
    return TYPE.CREATED;
  }

  getTypeOnEdit(padPrescription) {
    const padPrescriptionInLoadedData = this._findPadPrescriptionInLoadedData(padPrescription);

    if (!padPrescriptionInLoadedData) {
      return TYPE.CREATED;
    }

    const padPrescriptionPrevious = {
      ...padPrescriptionInLoadedData,
      ...this._returnOnlyForms(padPrescriptionInLoadedData)
    };

    const currentPadPrescription = {
      ...padPrescription,
      ...this._returnOnlyForms(padPrescription)
    };

    if (_.isNil(currentPadPrescription.type)) {
      throw new Error('Não foi identificado tipo do PAD Prescrição. Procurar suporte.');
    }
    if (currentPadPrescription.type === TYPE.SUSPENDED) {
      throw new Error('Tipo "Suspenso" não pode sofrer edição. Procurar suporte.');
    }
    if (currentPadPrescription.type === TYPE.GIVEN_DEADLINE) {
      throw new Error('Tipo "Aprazado" não pode sofrer edição. Procurar suporte.');
    }

    if (currentPadPrescription.type === TYPE.CREATED) {
      return TYPE.CREATED;
    }

    if (
      currentPadPrescription.type === TYPE.SUSTEINED ||
      currentPadPrescription.type === TYPE.CHANGED ||
      currentPadPrescription.type === TYPE.CHANGED_PERIOD
    ) {
      const hasPeriodChanged = padPrescriptionPrevious.period !== currentPadPrescription.period;

      const hasAnythingElseChanged =
        JSON.stringify(padPrescriptionPrevious) !== JSON.stringify(currentPadPrescription);

      const hasNotAnythingChanged =
        JSON.stringify(padPrescriptionPrevious) === JSON.stringify(currentPadPrescription);

      if (hasPeriodChanged) {
        return TYPE.CHANGED_PERIOD;
      } else if (hasAnythingElseChanged) {
        return TYPE.CHANGED;
      } else if (hasNotAnythingChanged) {
        return TYPE.SUSTEINED;
      } else {
        return TYPE.SUSTEINED;
      }
    }
  }

  getTypeOnSuspend(padPrescription) {
    const isPadPrescriptionTypeCreated = padPrescription.type === TYPE.CREATED;
    const isPadPrescriptionTypeSuspended = padPrescription.type === TYPE.SUSPENDED;

    if (isPadPrescriptionTypeCreated || isPadPrescriptionTypeSuspended) {
      return padPrescription.type;
    }

    const isPadPrescriptionTypeSusteined = padPrescription.type === TYPE.SUSTEINED;
    const isPadPrescriptionTypeChanged = padPrescription.type === TYPE.CHANGED;
    const isPadPrescriptionTypeChangedPeriod = padPrescription.type === TYPE.CHANGED_PERIOD;

    if (
      isPadPrescriptionTypeSusteined ||
      isPadPrescriptionTypeChanged ||
      isPadPrescriptionTypeChangedPeriod
    ) {
      return TYPE.SUSPENDED;
    }
  }

  findPadPrescriptionOnUnsuspend(padPrescription) {
    const isPadPrescriptionTypeSuspended = padPrescription.type === TYPE.SUSPENDED;

    if (isPadPrescriptionTypeSuspended) {
      const loadedPadPrescription = this._findPadPrescriptionInLoadedData(padPrescription);

      if (loadedPadPrescription) {
        const forms = this._returnOnlyForms(loadedPadPrescription);
        const type = TYPE.SUSTEINED;

        return {
          ...padPrescription,
          ...forms,
          type
        };
      }
    }

    return this._findPadPrescriptionInCurrentData(padPrescription);
  }

  _findPadPrescriptionInCurrentData(padPrescription) {
    const cPadPrescription = [...this._currentData].find(cPadPrescription => {
      return cPadPrescription.code === padPrescription.code;
    });

    return cPadPrescription;
  }

  _findPadPrescriptionInLoadedData(padPrescription) {
    const loadedData = [...this._loadedData];
    const { prescriptionTypeForm } = padPrescription;
    const { medicamentId, procedureId, dietId, prescriptionType } = prescriptionTypeForm;

    const matchingAttributeProperty = {
      [ITEM.MEDICAMENT]: 'medicamentId',
      [ITEM.DIET]: 'dietId',
      [ITEM.PROCEDURE]: 'procedureId'
    };
    const matchingAttributeValue = {
      [ITEM.MEDICAMENT]: medicamentId,
      [ITEM.DIET]: dietId,
      [ITEM.PROCEDURE]: procedureId
    };

    const attributeToMatchProperty = matchingAttributeProperty[prescriptionType];
    const attributeToMatchValue = matchingAttributeValue[prescriptionType];

    if (!attributeToMatchProperty || !attributeToMatchValue) {
      throw new Error('Erro inesperado. Procurar suporte. 165');
    }

    const padPrescriptionInLoadedData = loadedData.find(
      loadedPadPrescription =>
        loadedPadPrescription.prescriptionTypeForm[attributeToMatchProperty] ===
        attributeToMatchValue
    );

    return padPrescriptionInLoadedData;
  }

  _returnOnlyForms(padPrescription) {
    const {
      medicamentForm,
      dietForm,
      procedureForm,
      procedureKitForm,
      prescriptionTypeForm
      // ...rest
    } = padPrescription;

    const { prescriptionType } = prescriptionTypeForm;

    switch (prescriptionType) {
      case ITEM.MEDICAMENT:
        return { prescriptionTypeForm, medicamentForm };
      case ITEM.DIET:
        return { prescriptionTypeForm, dietForm };
      case ITEM.PROCEDURE:
        return { prescriptionTypeForm, procedureForm, procedureKitForm };
      default:
        throw new Error('Erro inesperado. Procurar suporte. 205');
    }
  }
}
